import { KycReviewDocumentType } from '__generated__/GQL';

export enum IdType {
  Id = 'ID',
  Passport = 'PASSPORT',
  ResidencePermit = 'RESIDENCE_PERMIT',
}

export const HOST_ID_DOCUMENT_TYPES: Record<IdType, KycReviewDocumentType[]> = {
  [IdType.Id]: [
    KycReviewDocumentType.IdRectoHost,
    KycReviewDocumentType.IdVersoHost,
  ],
  [IdType.ResidencePermit]: [
    KycReviewDocumentType.ResidencePermitRectoHost,
    KycReviewDocumentType.ResidencePermitVersoHost,
  ],
  [IdType.Passport]: [KycReviewDocumentType.PassportHost],
};
